const WebRenderHtml = ({ html, styles, color }) => (
  <div
    style={{ color: color || "black", ...styles, fontFamily: 'Poppins_400Regular' }}
    dangerouslySetInnerHTML={{ __html: html }}
  ></div>
);

export default WebRenderHtml;
